<div class="inscription-step3-card">

  <!-- Card header com ícone, título e descrição -->
  <div class="inscription-step3-card__top">
    <div class="inscription-step3-card__header">
      <div class="inscription-step3-card__icon" aria-hidden="true">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 16C3 8.26801 9.26801 2 17 2H37C44.732 2 51 8.26801 51 16V36C51 43.732 44.732 50 37 50H17C9.26801 50 3 43.732 3 36V16Z" fill="#FEF2F2"/>
          <path d="M20 15H34C35.1046 15 36 15.8954 36 17V37C36 38.1046 35.1046 39 34 39H20C18.8954 39 18 38.1046 18 37V17C18 15.8954 18.8954 15 20 15Z"
                stroke="#DA291C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M23 22H31M23 27H31M23 32H28" stroke="#DA291C" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="inscription-step3-card__text">
        <h2 class="inscription-step3-card__title">
          {{ 'pages.partnerRegistration.inscription.step3.title' | i18n }}
        </h2>
        <p class="inscription-step3-card__description">
          {{ 'pages.partnerRegistration.inscription.step3.description' | i18n }}
        </p>
      </div>
    </div>
  </div>

  <!-- Card body: formulário de perguntas -->
  <div class="inscription-step3-card__bottom">
    <form [formGroup]="partnerForm" class="questionnaire-step__form" novalidate>

      <!-- Pergunta 1: Estágio da startup -->
      <div class="questionnaire-block"
           [class.questionnaire-block--error]="partnerForm.get('startupStage')?.touched && partnerForm.get('startupStage')?.invalid">
        <h3 class="questionnaire-block__title">
          1. {{ base + '.startupStage.title' | i18n }}
        </h3>
        <mat-radio-group formControlName="startupStage" class="questionnaire-radio-group"
                         [attr.aria-label]="base + '.startupStage.title' | i18n">
          <mat-radio-button *ngFor="let opt of startupStageOptions" [value]="opt" class="questionnaire-radio-btn">
            {{ base + '.startupStage.options.' + opt | i18n }}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Pergunta 2: Tipo de negócio (multi-select) -->
      <div class="questionnaire-block"
           [class.questionnaire-block--error]="partnerForm.get('businessType')?.touched && partnerForm.get('businessType')?.invalid">
        <h3 class="questionnaire-block__title">
          2. {{ base + '.businessType.title' | i18n }}
        </h3>
        <div class="questionnaire-radio-group questionnaire-radio-group--grid questionnaire-radio-group--compact" 
             [attr.aria-label]="base + '.businessType.title' | i18n">
          <mat-checkbox *ngFor="let opt of businessTypeOptions"
                        [checked]="isBusinessTypeSelected(opt)"
                        (change)="toggleBusinessType(opt)"
                        class="questionnaire-radio-btn" style="padding: 0px !important;">
            {{ base + '.businessType.options.' + opt | i18n }}
          </mat-checkbox>
        </div>
      </div>

      <!-- Pergunta 3: Modelo de receita -->
      <div class="questionnaire-block"
           [class.questionnaire-block--error]="partnerForm.get('revenueModel')?.touched && partnerForm.get('revenueModel')?.invalid">
        <h3 class="questionnaire-block__title">
          3. {{ base + '.revenueModel.title' | i18n }}
        </h3>
        <mat-radio-group formControlName="revenueModel" class="questionnaire-radio-group questionnaire-radio-group--grid"
                         [attr.aria-label]="base + '.revenueModel.title' | i18n">
          <mat-radio-button *ngFor="let opt of revenueModelOptions" [value]="opt" class="questionnaire-radio-btn">
            {{ base + '.revenueModel.options.' + opt | i18n }}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Pergunta 4: Segmento principal — 2 colunas no desktop -->
      <div class="questionnaire-block"
           [class.questionnaire-block--error]="partnerForm.get('mainSegment')?.touched && partnerForm.get('mainSegment')?.invalid">
        <h3 class="questionnaire-block__title">
          4. {{ base + '.mainSegment.title' | i18n }}
        </h3>
        <mat-radio-group formControlName="mainSegment" class="questionnaire-radio-group questionnaire-radio-group--2col"
                         [attr.aria-label]="base + '.mainSegment.title' | i18n">
          <mat-radio-button *ngFor="let opt of mainSegmentOptions" [value]="opt" class="questionnaire-radio-btn">
            {{ base + '.mainSegment.options.' + opt | i18n }}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Pergunta 5: Escala de atuação -->
      <div class="questionnaire-block"
           [class.questionnaire-block--error]="partnerForm.get('operationScale')?.touched && partnerForm.get('operationScale')?.invalid">
        <h3 class="questionnaire-block__title">
          5. {{ base + '.operationScale.title' | i18n }}
        </h3>
        <mat-radio-group formControlName="operationScale" class="questionnaire-radio-group"
                         [attr.aria-label]="base + '.operationScale.title' | i18n">
          <mat-radio-button *ngFor="let opt of operationScaleOptions" [value]="opt" class="questionnaire-radio-btn">
            {{ base + '.operationScale.options.' + opt | i18n }}
          </mat-radio-button>
        </mat-radio-group>
      </div>

    </form>

    <div class="questionnaire-step__actions">
      <button
        type="button"
        class="wizard-btn wizard-btn--ghost"
        (click)="onBack()"
        [disabled]="isSubmitting"
      >
        {{ 'pages.partnerRegistration.inscription.step3.actions.back' | i18n }}
      </button>
      <button
        type="button"
        class="wizard-btn wizard-btn--primary"
        (click)="onSubmit()"
        [disabled]="isSubmitting"
      >
        {{ isSubmitting
          ? ('pages.partnerRegistration.inscription.step3.actions.submitting' | i18n)
          : ('pages.partnerRegistration.inscription.step3.actions.submit' | i18n) }}
      </button>
    </div>
  </div>

</div>
